import { autoinject, transient } from "aurelia-dependency-injection";
import { BaseRedMarblePlugin } from "./base-red-marble";
import { UserClaimsService } from "../../../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../../../constants/authentication/claims";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../../../../configuration/rightshipqi-router.constants";
import { Md5 } from "../../../../../../../../utilities/md5";
import { IncidentService } from "../../../../../../../../services/incident/incident.service";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class Inci extends BaseRedMarblePlugin {

    canAddInc: boolean;
    constructor(private incService: IncidentService, private userClaimsService: UserClaimsService, private router: Router) {
        super();
        this.canAddInc = this.userClaimsService.hasPermission(Claims.CanAddIncident);
    }

    @computedFrom(Reflection.getPropertyPath<Inci>(z => z.data),
        Reflection.getPropertyPath<Inci>(z => z.data.data),
        Reflection.getPropertyPath<Inci>(z => z.data.data.incidents),
        Reflection.getPropertyPath<Inci>(z => z.data.data.incidents.length),
        Reflection.getPropertyPath<Inci>(z => z.rsData))
    get incs() {
        if (!this.data || !this.data.data  || !this.data.data.incidents || this.data.data.incidents.length == 0)
            return null;

        const ignored = this.rsData ? this.rsData : [];

        for (const p of this.data.data.incidents)
            p.id = Md5.hashStr(this.getIncString(p));

        return this.data.data.incidents.filter(x => ignored.indexOf(x.id) == -1);
    }

    getIncString(inc) {
        let str = "";

        str += `Source_${inc.source ? inc.source : ''}_`;
        str += `Date_${inc.dateTime ? inc.dateTime : ''}_`;
        str += `Ref_${inc.sourceId ? inc.sourceId : ''}_`;

        return str;
    }

    createInc(item: {
        dateTime: Date,
        latitude: number,
        longitude: number,
        preliminaryText: string,
        numberKilled: number,
        numberMissing: number,
        pollutionOccurred: boolean,
        hadDangerousCargo: boolean,
        isTotalLoss: boolean,
        summary: string,
        casualtyType: string,
        events: {
            dateTime: Date,
            initialCause: string,
            action: string,
            component: string,
            position: string
        }[]
    }) {
        if (this.canAddInc) {
            this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.AddIncident,
                {
                    id: 0,
                    vesselId: this.vet.vesselId,
                    internationalMaritimeOrganizationNumber:
                        this.vet.internationalMaritimeOrganizationNumber ? this.vet.internationalMaritimeOrganizationNumber : '0',
                    vesselName: this.vet.vesselName,
                    dateTime: item.dateTime,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    preliminaryText: item.preliminaryText,
                    numberKilled: item.numberKilled,
                    numberMissing: item.numberMissing,
                    pollutionOccurred: item.pollutionOccurred,
                    hadDangerousCargo: item.hadDangerousCargo,
                    isTotalLoss: item.isTotalLoss,
                    summary: item.summary,
                    casualtyType: item.casualtyType,
                    events: item.events ? item.events.map(x => {
                        return {
                            dateTime: x.dateTime,
                            initialCause: x.initialCause,
                            action: x.action,
                            component: x.component,
                            position: x.position
                        };
                    }) : []
                });
        }
    }

    async removeInc(item: { id: string, isRemovingInc: boolean }) {
        item.isRemovingInc = true;
        try {
            this.vetTask.rightshipPayload = await this.incService.removeInc(this.vet.vesselId, item.id);
            this.loadData();
        } catch (e) {
            console.error("error removing inc", e);
        }
        finally {
            item.isRemovingInc = false;
        }
    }


    navigateToUrl(url: string) {
        window.open(url, '_blank').focus();
    }

    replace(txt){
        return txt? txt.replace(/\\r\\n/g, " "): "";
    }

    // {"correlationId":"d6cf596e-39c8-40ef-9d95-9d282557e9c2","fallbackString":"No incidents were found for this vessel.","data":{{
    //     "incidents": [
    //         {
    //             "id": 1,
    //             "source": "TSBC",
    //             "sourceId": "M20P0110",
    //             "dateTime": "2021-01-05T00:00:00+11:00",
    //             "isTotalLoss": false,
    //             "hadDangerousCargo": false,
    //             "pollutionOccurred": false,
    //             "severity": "Serious",
    //             "casualtyType": "Collision",
    //             "numberKilled": 0,
    //             "numberMissing": 1,
    //             "location": "Gibraltar",
    //             "country": "Australia",
    //             "latitude": 30.0,
    //             "longitude": 145.5,
    //             "url": "https://www.tsb.gc.ca/eng/enquetes-investigations/marine/2020/M20P0110/M20P0110.html",
    //             "status": "Completed",
    //             "title": "Striking\r\nRoll-on/roll-off passenger ferry Spirit of Vancouver Island\r\nTsawwassen, British Columbia",
    //             "summary": "...",
    //             "preliminaryText": "Striking\r\nRoll-on/roll-off passenger ferry Spirit of Vancouver Island\r\nTsawwassen, British Columbia",
    //             "fullText": "Marine traeferrer\r\n",
    //             "lastPublishedDateTime": "2021-01-05T00:00:00+11:00",
    //             "lastRetrievedDateTime": "2021-11-17T00:00:00+11:00",
    //             "vessels": [
    //                 {
    //                     "imo": "9692662",
    //                     "name": "Ship A"
    //                 },
    //                 {
    //                     "imo": "9838058",
    //                     "name": "Ship B"
    //                 }
    //             ],
    //             "events": [
    //                 {
    //                     "id": 1000,
    //                     "sequence": 1,
    //                     "dateTime": "2021-01-05T00:00:00+11:00",
    //                     "vesselImo": "9692662",
    //                     "initialCause": null,
    //                     "action": null,
    //                     "component": null,
    //                     "position": null
    //                 },
    //                 {
    //                     "id": 1001,
    //                     "sequence": 2,
    //                     "dateTime": "2021-01-05T00:00:00+11:00",
    //                     "vesselImo": "9838058",
    //                     "initialCause": null,
    //                     "action": null,
    //                     "component": null,
    //                     "position": null
    //                 }
    //             ]
    //         }
    //     ]
    // }}

}